import { Link } from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react'

import type { AiPlanView } from 'services/aiService'

import { kindLabel, resultLinks } from '../plan/planSteps'

/**
 * Where to find what a run made (MYD-624): the location and project pages,
 * the evaluation, `/explorer/:grain?report=<id>`, the deck editor. The server
 * decides each address (ai/executorOps.js `urlFor`), so the card never builds
 * a route of its own and cannot drift from the app's.
 *
 * In-app links, so the conversation stays open beside the page they open.
 */

export function ResultLinks({ view }: { view: Pick<AiPlanView, 'plan' | 'results'> }) {
	const links = resultLinks(view)
	if (!links.length) return null
	return (
		<nav aria-label="What the plan made" className="space-y-1">
			<h4 className="text-xs font-medium uppercase tracking-wide text-gray-500">Open</h4>
			<ul className="flex flex-wrap gap-1.5">
				{links.map(link => (
					<li key={link.stepId}>
						<Link
							to={link.url}
							className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-2.5 py-1 text-xs text-gray-800 hover:border-primary hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
						>
							<span className="text-gray-500">{kindLabel(link.kind)}</span>
							<span className="font-medium">{link.label}</span>
							<ArrowUpRight className="h-3 w-3" aria-hidden="true" />
						</Link>
					</li>
				))}
			</ul>
		</nav>
	)
}

export default ResultLinks
